import React from 'react';
import {IUserContext} from '../@interfaces/contexts/IUserContext';

let userInstance: Pick<IUserContext, 'can' | 'cant' | 'canAny' | 'cannotAny'> | null = null;

export function setUserInstance(instance: typeof userInstance): void {
    userInstance = instance;
}

export const defaultUserContext: IUserContext = {
    preferences: {},

    can(...permissions): boolean {
        return userInstance?.can(...permissions) ?? false;
    },

    cant(...permissions): boolean {
        return userInstance?.cant(...permissions) ?? false;
    },

    canAny(...permissions): boolean {
        return userInstance?.canAny(...permissions) ?? false;
    },

    cannotAny(...permissions): boolean {
        return userInstance?.cannotAny(...permissions) ?? false;
    }
};

export const UserContext = React.createContext<IUserContext | null>(defaultUserContext);
